<script setup lang="ts">
import { useAuthStore } from "@/stores/auth";
import { useRoute } from "vue-router";

const authStore = useAuthStore();
const route = useRoute();
</script>

<template>
  <div class="profileMenu">
    <ul>
      <!-- <li v-if="authStore.isAdmin">
        <router-link active-class="active" to="/adm/panel">Visão Geral</router-link>
      </li> -->
      <li v-if="authStore.isAdmin">
        <router-link to="/adm/users">Usuários</router-link>
      </li>
      <li v-if="authStore.isAdmin">
        <router-link
          :class="{
            'router-link-exact-active': [
              '/adm/broadcast-messages',
              '/adm/new-broadcast-message',
            ].includes(route.fullPath),
          }"
          to="/adm/broadcast-messages"
          >Mensagens</router-link
        >
      </li>
      <li v-if="authStore.isAdmin">
        <router-link to="/adm/account-deletion-requests">Exclusões de Conta</router-link>
      </li>
      <li>
        <router-link to="/user/my-personal-data">Dados Pessoais</router-link>
      </li>
      <!-- <li v-if="!authStore.isAdmin"> -->
      <li>
        <router-link to="/user/subscriptions">Minha Assinatura</router-link>
      </li>
      <!-- <li v-if="!authStore.isAdmin"> -->
      <!-- <li>
        <router-link to="/user/my-billing-history"> Histórico de Cobranças</router-link>
      </li> -->
      <li>
        <router-link to="/user/change-password">Alterar Senha</router-link>
      </li>
      <li class="d-md-none">
        <router-link to="/auth/logout">Sair</router-link>
      </li>
    </ul>
  </div>
</template>

<style scoped>
.profileMenu h5 {
  font-size: 14px;
  font-weight: 500;
  margin: 0 0 10px;
  color: var(--primary-color);
}

.profileMenu ul {
  padding-left: 0;
  flex-direction: column;
  list-style-type: none;
}

.profileMenu ul li {
  border: none;
  margin-bottom: 20px;
  width: 100%;
  color: var(--white-ice);
}

ul li::before {
  color: var(--primary-color);
}

.profileMenu ul li:last-child {
  margin-bottom: 0;
}

.profileMenu a {
  text-decoration: none;
  color: var(--white-ice);
}

.profileMenu a:hover {
  color: var(--primary-color);
}

.profileMenu a:active {
  color: var(--primary-color);
}

.profileMenu .router-link-exact-active {
  color: var(--primary-color);
}

@media (max-width: 767.98px) {
  .profileMenu {
    margin: 0;
    padding: 5px 10px 0px;
  }

  .profileMenu ul {
    padding-inline-start: 0px;
  }
}

@media (max-width: 575.98px) {
  .profileMenu ul li {
    border: none;
  }
}
</style>
